import { render, staticRenderFns } from "./case-related-request.vue?vue&type=template&id=e4dce6d2&"
import script from "./case-related-request.vue?vue&type=script&lang=js&"
export * from "./case-related-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports